/**
 * Devuelve las iniciales de un nombre completo (máx 2 letras).
 */
export function initials(fullName: string): string {
  return fullName
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p.charAt(0).toUpperCase())
    .join('');
}

/**
 * Calcula la antigüedad en años a partir de la fecha de ingreso.
 */
export function tenureInYears(hireDate: Date | string): number {
  const date = typeof hireDate === 'string' ? new Date(hireDate) : hireDate;
  const ms = Date.now() - date.getTime();
  return Math.floor(ms / (1000 * 60 * 60 * 24 * 365.25));
}

/**
 * Formatea fechas como "07 abr 2026" en español.
 */
export function formatDateEs(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
}

/**
 * Formatea una fecha "solo fecha" SIN corrimiento de zona horaria.
 *
 * Las columnas `@db.Date` (fechas de vacaciones, feriados, ingreso) llegan del
 * backend como ISO en UTC, p.ej. "2026-07-31T00:00:00.000Z". Si se formatean con
 * `new Date(iso).toLocaleDateString()` en una zona detrás de UTC (Guatemala UTC-6),
 * la medianoche UTC cae en el día anterior y la fecha se muestra corrida (jul 30).
 *
 * Esta función toma solo la parte YYYY-MM-DD y construye una fecha LOCAL, por lo
 * que el día mostrado siempre coincide con el día seleccionado.
 */
export function formatDateOnly(
  value: Date | string | null | undefined,
  opts: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short', year: 'numeric' },
): string {
  if (!value) return '';
  const iso = typeof value === 'string' ? value : value.toISOString();
  const datePart = iso.slice(0, 10); // "2026-07-31"
  const [y, m, d] = datePart.split('-').map(Number);
  if (!y || !m || !d) return '';
  return new Date(y, m - 1, d).toLocaleDateString('es', opts);
}
